<ng-template #videoTemplate let-id="id" let-controls="controls">
  <video #video class="video-js vjs-default-skin vjs-big-play-centered fill"
         [id]="id"
         [preload]="preload"
         [muted]="muted"
         [attr.playsinline]="inline"
         [attr.webkit-playsinline]="inline"
         controls>
  </video>
</ng-template>
